export enum CertificationProviderTypeEnum {
    External = 0,
    Internal = 1,
    Other = 2,
}
